import portalApi, { clearPortalToken, setPortalToken } from './portalApi';

export interface ClientLoginCredentials {
  clientUserName: string;
  clientUserPassword: string;
}

export interface ClientLoginResponse {
  access_token: string;
}

export const portalAuthService = {
  async clientLogin(credentials: ClientLoginCredentials): Promise<ClientLoginResponse> {
    const { data } = await portalApi.post<ClientLoginResponse>('/auth/client_login', credentials);
    setPortalToken(data.access_token);
    return data;
  },

  async clientLogout(): Promise<void> {
    try {
      await portalApi.delete('/auth/client_logout');
    } finally {
      clearPortalToken();
    }
  },

  async validateClientSession(): Promise<{ message: string }> {
    const { data } = await portalApi.post<{ message: string }>('/auth/validate-client-session');
    return data;
  },

  getToken: () => typeof window !== 'undefined' ? localStorage.getItem('portal_access_token') : null,
  setToken: setPortalToken,
  clearToken: clearPortalToken,
};
